/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var SendPaperplaneIcon16Light = forwardRef('SendPaperplaneIcon16Light', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 16 }, props),
        React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M1.794 2.774C1.6 1.754 2.664.956 3.59 1.427l10.73 5.459a1.25 1.25 0 0 1 0 2.228l-10.73 5.46c-.926.47-1.989-.328-1.795-1.348L2.788 8l-.994-5.226ZM3.711 8.5l-.934 4.913a.25.25 0 0 0 .359.27l10.73-5.46a.25.25 0 0 0 0-.446L3.135 2.318a.25.25 0 0 0-.36.27L3.712 7.5h3.91a.5.5 0 0 1 0 1h-3.91Z" })));
});
